<template>

  <div id="page-user-list">
    <div class="vx-card p-6">

      <div class="flex flex-wrap items-center">
        
        <table border="1">
<tr>
  <td style="padding: 5px;"><b>Instructor Name: </b></td>
  <td style="padding: 5px;">
    {{ teacher_name }}
  </td>
</tr>
<tr>
  <td style="padding: 5px;"><b>Student Name: </b></td>
  <td style="padding: 5px;">
    {{ student_name }}
  </td>
</tr>
<tr>
  <td style="padding: 5px;"><b>Review Text: </b></td>
  <td style="padding: 5px;">
    {{ review_text }}
  </td>
</tr>
<tr>
  <td style="padding: 5px;"><b>Explanation of the exercise: </b></td>
  <td style="padding: 5px;">
    {{ review1 }}
  </td>
</tr>
<tr>
  <td style="padding: 5px;"><b>Assistence from the Instructor: </b></td>
  <td style="padding: 5px;">
    {{ review2 }}
  </td>
</tr>
<tr>
  <td style="padding: 5px;"><b>Overall Experience: </b></td>
  <td style="padding: 5px;">
    {{ review3 }}
  </td>
</tr>
<tr>
  <td style="padding: 5px;"><b>Seen Learning Video? </b></td>
  <td style="padding: 5px;">
    {{ learning_video_seen }}
  </td>
</tr>
<tr>
  <td style="padding: 5px;"><b>Is Complaint? </b></td>
  <td style="padding: 5px;">
    {{ is_complaint }}
  </td>
</tr>
<tr>
  <td style="padding: 5px;"><b>Date: </b></td>
  <td style="padding: 5px;">
    {{ date }}
  </td>
</tr>   
</table>
  

      </div>

        
    </div>
  </div>

</template>

<script>

import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'


// Store Module
import moduleManoeuvreRatingManagement from '@/store/manoeuvre-rating/moduleManoeuvreRatingManagement.js'



export default {
  components: {
    
  },
  data() {
    return {

      teacher_name: '',
      student_name: '',
      review_text: '',
      review1: '',
      review2: '',
      review3: '',
      date: '',
      learning_video_seen: '',
      is_complaint: ''

    }
  },
  watch: {
    
  },
  computed: {
    
    
  },
  methods: {
  },
  mounted() {
  },
  created() {
    
    if(!moduleManoeuvreRatingManagement.isRegistered) {
        console.log('is registered not');
      this.$store.registerModule('manoeuvreratingManagement', moduleManoeuvreRatingManagement)
      moduleManoeuvreRatingManagement.isRegistered = true
    }

    this.$store.dispatch("manoeuvreratingManagement/fetchRatings", {
      id: this.$route.params.ratingId
    })
      .then(res => { 
          this.teacher_name = res.data[0].teacher.name + ' ' + res.data[0].teacher.last_name
          this.student_name = res.data[0].student.name + ' ' + res.data[0].student.last_name
          this.review_text = res.data[0].review

          this.review1 = res.data[0].rating1
          this.review2 = res.data[0].rating2
          this.review3 = res.data[0].rating3
          this.date = res.data[0].created_at
          this.learning_video_seen = (res.data[0].learning_video_seen === 1) ? 'Yes' : 'No'
          this.is_complaint = (res.data[0].is_complaint === 1) ? 'Yes' : 'No'
          
          //this.learning_video_seen = res.data[0].learning_video_seen

        })
      .catch(err => {
        
        console.error(err) }
    )

  }
}

</script>



<style type="text/css">

.pagidropdown{
    padding: 11px!important;
}

.rounded-full {
    border-radius: 7px !important;
}

.teacherSearchBtn{
  width: 34% ! important;
}

.teacherSearchStatus{
  width: 17% ! important;
}

.teacherSearchEmail{
  width: 17% ! important;
}
</style>